function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "Array", () => $24b828e2c0ac7de2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "assert", () => $2c78cbd652541061$export$a7a9523472993e97);
$parcel$export(module.exports, "isEquivalent", () => $84c84b328e1b047d$export$2c3070a504066332);
$parcel$export(module.exports, "pointee", () => $f6056fdcef89ff06$export$46838187e754e06c);
$parcel$export(module.exports, "tree", () => $f6056fdcef89ff06$export$4767d4262788a6cc);
// 
// index.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Array.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Assertions.js
// Cacao
// 
// Created on 9/6/22
// 
function $2c78cbd652541061$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}


class $24b828e2c0ac7de2$var$_Array extends Array {
    copy() {
        return this.slice(0);
    }
    append(element) {
        (0, $2c78cbd652541061$export$a7a9523472993e97)(element, "`element` is required.");
        this.push(element);
    }
    appendContentsOf(array) {
        (0, $2c78cbd652541061$export$a7a9523472993e97)(array, "`array` is required.");
        (0, $2c78cbd652541061$export$a7a9523472993e97)(Array.isArray(array), "`array` needs to be an Array.");
        this.push(...array);
    }
    insertAt(element, index) {
        (0, $2c78cbd652541061$export$a7a9523472993e97)(element, "`element` is required.");
        (0, $2c78cbd652541061$export$a7a9523472993e97)(index >= 0 && index <= this.count, "`index` is out of bounds.");
        this.splice(index, 0, element); // insert `element` at index `index`.
    }
    removeFirst(element) {
        (0, $2c78cbd652541061$export$a7a9523472993e97)(element, "`element` is required.");
        const index = this.indexOf(element);
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeLast() {
        const count = this.count;
        if (count > 0) return this.removeAt(count - 1);
        return undefined;
    }
    removeAt(index) {
        (0, $2c78cbd652541061$export$a7a9523472993e97)(index >= 0 && index < this.count, "`index` is out of bounds.");
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeAll(whereFn) {
        if (whereFn) {
            const elements = this.filter((element, index)=>!whereFn(element, index));
            this.length = 0;
            this.push(...elements);
        } else this.length = 0;
    }
    swapAt(fromIndex, toIndex) {
        const count = this.count;
        (0, $2c78cbd652541061$export$a7a9523472993e97)(fromIndex >= 0 && fromIndex < count, "`fromIndex` is out of bounds.");
        (0, $2c78cbd652541061$export$a7a9523472993e97)(toIndex >= 0 && toIndex < count, "`toIndex` is out of bounds.");
        if (fromIndex == toIndex) return;
        this.splice(toIndex, 0, this.splice(fromIndex, 1)[0]);
    }
    contains(element) {
        (0, $2c78cbd652541061$export$a7a9523472993e97)(element, "`element` is required.");
        return this.indexOf(element) != -1;
    }
    get isEmpty() {
        return this.length <= 0;
    }
    get first() {
        const count = this.count;
        if (count > 0) return this[0];
        return undefined;
    }
    get last() {
        const count = this.count;
        if (count > 0) return this[count - 1];
        return undefined;
    }
    get count() {
        return this.length;
    }
}
var $24b828e2c0ac7de2$export$2e2bcd8739ae039 = $24b828e2c0ac7de2$var$_Array;



// 
// Equivalence.js
// Cacao
// 
// Created on 9/6/22
// 
function $84c84b328e1b047d$export$2c3070a504066332(a, b) {
    if (a === b) return true;
    if (typeof a != "object" || typeof b != "object" || a == null || b == null) return false;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length != keysB.length) return false;
    for (let key of keysA){
        if (!keysB.includes(key)) return false;
        if (typeof a[key] === "function" || typeof b[key] === "function") {
            if (a[key].toString() != b[key].toString()) return false;
        } else {
            if (!$84c84b328e1b047d$export$2c3070a504066332(a[key], b[key])) return false;
        }
    }
    return true;
}


// 
// Logging.js
// Cacao
// 
// Created on 9/6/22
// 
function $f6056fdcef89ff06$export$46838187e754e06c(instance) {
    let pointee;
    try {
        pointee = instance.constructor?.name || instance.toString();
    } catch  {
        pointee = "[Unknown]";
    }
    return pointee;
}
function $f6056fdcef89ff06$export$4767d4262788a6cc(root, name, children) {
    return new $f6056fdcef89ff06$var$TreeGrapher(name, children).parse(root);
}
class $f6056fdcef89ff06$var$TreeGrapher {
    constructor(name, children, limit = 1000){
        this.settings = {
            keyword: {
                name: name,
                children: children
            },
            maxLevel: limit
        };
    }
    setPre(level, hasNext, parentPre = "") {
        return `${parentPre}${hasNext ? "├" : "└"}── `;
    }
    setTransferPre(parentPre = "", hasNext) {
        return `${parentPre}${hasNext ? "│" : " "}   `;
    }
    parse(tree, level = 0, parentPre = "", treeStr = "") {
        if (!this.check(tree, level)) return "";
        if (Array.isArray(tree)) tree.forEach((child, index)=>{
            const hasNext = tree[index + 1] ? true : false;
            const children = child[this.settings.keyword.children];
            treeStr += `${this.setPre(level, hasNext, parentPre)}${child[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1, this.setTransferPre(parentPre, hasNext));
        });
        else {
            const children = tree[this.settings.keyword.children];
            treeStr = `${tree[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1);
        }
        return treeStr;
    }
    check(tree, level) {
        if (typeof tree !== "object") return false;
        if (level >= this.settings.maxLevel) return false;
        return true;
    }
}




//# sourceMappingURL=index.js.map
